import React, { useEffect } from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom'
import { Footer } from 'goustouicomponents'
import { cookieBanner } from '@gousto-internal/storage-consent-web-package'
import { TermsAndConditions } from '../../routes/TermsAndConditions'
import { TermsOfUse } from '../../routes/TermsOfUse'
import { HeaderContainer } from '../HeaderContainer'
import '@gousto-internal/storage-consent-web-package/dist/storageConsentBanner.css'

const AppContent = () => {
  useEffect(() => {
    cookieBanner.init()
  }, [])

  return (
    <>
      <HeaderContainer />
      <Router>
        <Switch>
          <Route path="/terms-and-conditions" component={TermsAndConditions} />
          <Route path="/terms-of-use" component={TermsOfUse} />
        </Switch>
      </Router>
      <Footer />
    </>
  )
}

export { AppContent }
